var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
export function meshTilesetFlyover3(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Mesh Tileset Flyover 3" +
                "</h1>" +
                "<p>" +
                "The camera will fly over a mesh tileset. The tileset should render normally." +
                "</p>";
        const initialWait = 5;
        const time = 2;
        const durations = [0, initialWait, time, time, time, time, time, time];
        const positions = [
            { longitude: -1.2917942845106056, latitude: 0.7105477029879864, height: 4.33746030234476 },
            { longitude: -1.2917942845106056, latitude: 0.7105477029879864, height: 4.33746030234476 },
            { longitude: -1.291708703826157, latitude: 0.7105572330529882, height: 392.4279067481268 },
            { longitude: -1.2918092004816606, latitude: 0.7106379113635606, height: 381.1827147611314 },
            { longitude: -1.2918139524814456, latitude: 0.7105537928135903, height: 302.0588548423521 },
            { longitude: -1.2915665415032023, latitude: 0.7108514650549642, height: 163.02041970934997 },
            { longitude: -1.291056373691382, latitude: 0.7116769608410789, height: 355.44100200676166 },
            { longitude: -1.2911799192253008, latitude: 0.7115137959403458, height: 2.60748803580262 },
        ];
        const focuses = [
            { longitude: -1.291775434346592, latitude: 0.7105753983262475, height: 276.0544015120512 },
            { longitude: -1.291775434346592, latitude: 0.7105753983262475, height: 276.0544015120512 },
            { longitude: -1.291775434346592, latitude: 0.7105753983262475, height: 276.0544015120512 },
            { longitude: -1.291775434346592, latitude: 0.7105753983262475, height: 276.0544015120512 },
            { longitude: -1.291775434346592, latitude: 0.7105753983262475, height: 276.0544015120512 },
            { longitude: -1.291522799943311, latitude: 0.7109019444589085, height: 2.349780915309842 },
            { longitude: -1.291522799943311, latitude: 0.7109019444589085, height: 2.349780915309842 },
            { longitude: -1.2914504973560825, latitude: 0.7111421572330594, height: 1.2029563738210192 },
        ];
        const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJkZWRiYmRiYi00NzkwLTRhNmUtOTNjNS0xNTdmMmQ2YWU2YjYiLCJpZCI6NjU2MjMsImlhdCI6MTYzMDM4MDgyNn0.AkraHLm6RAZZDYB9Rqf3kcrOC8Lx9Iu2aYg2aO3jIbM";
        yield sceneFlyover(defaultRendererConfig(container, token), durations, positions, focuses, (renderer) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "cesium",
                assetId: 75343,
            });
            renderer.getWorld().addObject(object);
        }));
    });
}
